import React, { FC, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch } from "react-redux";

const { TextArea } = Input;

const PageSummaryModal: FC<{ onClose: () => void }> = ({ onClose }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [page, setPage] = useState<string>("");

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };
  const dispatch = useDispatch();
  const handleOk = () => {
    if (page !== undefined && page !== "") {
      dispatch({
        type: "SEND_MESSAGE",
        payload: {
          message: `${page} (Page Summary)`,
          type: "summary",
          data: { title: page, pageId: page },
        },
      });
    }
    setIsModalVisible(false);
  };

  return (
    <Modal
      title="Page summary"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Row>
        <Col span={24}>
          <Input
            value={page}
            onChange={(e) => {
              setPage(e.target.value);
            }}
            placeholder="Page id"
          />
        </Col>
      </Row>
      <Row className="action-grp mt-4">
        <Col span={14} className="pr-2">
          <Button
            className="beam-btn green-btn cover w-full"
            onClick={handleOk}
          >
            Add
          </Button>
        </Col>
        <Col span={10} className="pl-2">
          <Button
            className="beam-btn orange-btn bordered w-full"
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default PageSummaryModal;
